import React from "react";
import { Card, Tooltip } from "@mui/material";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

const UsageCard = ({ title, color, value, maxValue, unit, tooltip }) => {
  const progress = (value / maxValue) * 100;

  const progressBarContainerStyle = {
    backgroundColor: `${color}33`,
    borderRadius: "4px",
    overflow: "hidden",
    height: "8px",
    width: "100%",
  };

  const progressBarStyle = {
    backgroundColor: color,
    height: "100%",
    width: `${progress}%`,
    borderRadius: "4px",
    transition: "width 0.3s ease",
  };

  return (
    <Card
      sx={{
        height: "100%",
        padding: {
          xs: 1, // 8px
          sm: 1.5, // 12px
          md: 2, // 16px
        },
      }}
    >
      <Tooltip title={tooltip || ""} arrow enterDelay={1000} leaveDelay={200}>
        <VuiBox
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          height="100%"
          sx={{
            cursor: tooltip ? "pointer" : "default",
          }}
        >
          <VuiTypography
            variant="h6"
            color="white"
            mb={1}
            sx={{
              fontSize: {
                xs: "0.875rem", // ~14px
                sm: "1rem",     // ~16px
                md: "1.25rem",  // ~20px
              },
              lineHeight: 1.3,
            }}
          >
            {title}
          </VuiTypography>

          <VuiBox sx={{ flex: 1 }}>
            <VuiBox sx={progressBarContainerStyle}>
              <VuiBox sx={progressBarStyle} />
            </VuiBox>
          </VuiBox>

          <VuiTypography
            variant="body2"
            color="white"
            mt={1}
            sx={{
              fontSize: {
                xs: "0.75rem", // ~12px
                sm: "0.875rem", // ~14px
                md: "1rem",     // ~16px
              },
              fontWeight: "bold",
            }}
          >
            {`${value} ${unit}`}
          </VuiTypography>
        </VuiBox>
      </Tooltip>
    </Card>
  );
};

export default UsageCard;
